// extracted by mini-css-extract-plugin
export var alignCenter = "_b6-d";
export var bannerShown = "_b6-6";
export var buttonContent = "_b6-0";
export var cardList = "_b6-1";
export var centerContent = "_b6-2";
export var chevron = "_b6-3";
export var closePanelButton = "_b6-k";
export var conversationContextContainer = "_b6-l";
export var conversationDetailContainer = "_b6-4";
export var detailWrapper = "_b6-7";
export var dropdownButton = "_b6-e";
export var dropdownTitle = "_b6-9";
export var fullHeight = "_b6-5";
export var hidden = "_b6-a";
export var icon = "_b6-b";
export var mergeSuggestionWrapper = "_b6-m";
export var panel = "_b6-i";
export var portalButtonsWrapper = "_b6-c";
export var right = "_b6-j";
export var tableSummaryContainer = "_b6-8";
export var tableSummaryHeader = "_b6-g";
export var threeDotsButton = "_b6-f";
export var wide = "_b6-h";